/**
 * Public referral landing — /refer/{code}.
 * Stores the code in localStorage and routes to the trial signup flow.
 */
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function ReferLandingPage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      localStorage.setItem('ss_referred_by_code', code);
    }
    // Send the user to the marketing trial flow
    navigate('/?ref=' + encodeURIComponent(code || ''), { replace: true });
  }, [code, navigate]);

  return null;
}
